import { PageCodeType } from './page-code-type';
import { PageCode } from './page-code';

export class PageCodeModel {
    public readonly pageCode: PageCode | string;
    public readonly addCopy: string;
    public readonly remove: string;
    public readonly edit: string;
    public readonly list: string;
    public readonly filter: string;

    constructor(private pc: PageCode | string) {
        this.pageCode = pc;
        this.addCopy = `${this.pageCode}${PageCodeType.ADD_OR_COPY}`;
        this.remove = `${this.pageCode}${PageCodeType.REMOVE}`;
        this.edit = `${this.pageCode}${PageCodeType.EDIT}`;
        this.list = `${this.pageCode}${PageCodeType.LIST}`;
        this.filter = `${this.pageCode}${PageCodeType.FILTER}`;
    }
}
